let digestAlgorithm = [
  'SHA1',
  'SHA256',
  'SHA384',
  'SHA512'
]

export default digestAlgorithm
